import { render, staticRenderFns } from "./BulkInventoryItemFilters.vue?vue&type=template&id=6d6a4748&scoped=true"
import script from "./BulkInventoryItemFilters.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItemFilters.vue?vue&type=script&lang=ts"
import style0 from "./BulkInventoryItemFilters.vue?vue&type=style&index=0&id=6d6a4748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a4748",
  null
  
)

export default component.exports